import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

import { HALF_WIDTH, FULL_WIDTH } from 'bento-ordering/base/constants/grid';

const TWO_COL_GRID_ITEM = {
  md: HALF_WIDTH,
  sm: FULL_WIDTH,
  xs: FULL_WIDTH
};
const MenuSectionGrid = ({ children }) => {
  const theme = useTheme();
  const isMediumAndUp = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Grid container component={List}>
      {children.map((child, idx) => {
        const cardWrapperMargin = '14px';
        return (
          <Grid
            item
            key={child.props.id}
            {...TWO_COL_GRID_ITEM}
            component={ListItem}
            style={
              isMediumAndUp
                ? {
                    [idx % 2 === 0 ? 'paddingRight' : 'paddingLeft']: '12px',
                    marginBottom: cardWrapperMargin
                  }
                : { marginBottom: cardWrapperMargin }
            }
          >
            {child}
          </Grid>
        );
      })}
    </Grid>
  );
};

MenuSectionGrid.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default MenuSectionGrid;
